import {
  createContext,
  useContext,
  type SetStateAction,
  type Dispatch,
} from "react";

import type { HotelBooking } from "@/features/hotels/types/types";

export interface HotelBookingContextValue {
  data: HotelBooking | null;
  setData: Dispatch<SetStateAction<HotelBooking | null>>;
  availabilityToken: string | null;
  promoCode: string | null;
  setAvailabilityToken: (token: string | null) => void;
  setPromoCode: (code: string | null) => void;
  resetBooking: () => void;
}

export const HotelBookingContext = createContext<HotelBookingContextValue>({
  data: null,
  setData: (data) => data,
  availabilityToken: null,
  promoCode: null,
  setAvailabilityToken: () => {},
  setPromoCode: () => {},
  resetBooking: () => {},
});

export const useHotelBookingContext = () => useContext(HotelBookingContext);
